import { render } from "./CommentZone.vue?vue&type=template&id=aec0a444&ts=true"
import script from "./CommentZone.vue?vue&type=script&lang=ts"
export * from "./CommentZone.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/app/releases/1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__